import { StatusBadge, IStatusBadgeProps } from '../../../StatusBadge';

import {
  ModalFooterActions,
  IModalFooterActionsProps,
} from './ModalFooterActions';

export interface IFooterProps {
  actions?: IModalFooterActionsProps;
  statuses: IStatusBadgeProps[];
}

/**
 * -----------------------------------------------------------------------------
 * It renders a footer with a status badge and modal footer actions
 */
export function Footer({ actions, statuses }: Readonly<IFooterProps>) {
  return (
    <div className="footer flex flex-col items-start gap-y-4 px-4 py-2 sm:flex-row sm:items-center">
      <div className="flex grow flex-col gap-2 sm:flex-row">
        {statuses.map((status) => (
          <StatusBadge key={status.label} {...status} type="solid" />
        ))}
      </div>
      {actions ? <ModalFooterActions {...actions} /> : null}
    </div>
  );
}
